// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Display selected report'"></sub-header>

  <report-filters config="\$ctrl.filterConfig" params="\$ctrl.params"></report-filters>

  <report-view descriptor="\$ctrl.descriptor" report-content="\$ctrl.reportContent"></report-view>

  <!-- Empty report content -->
  <div class="empty-message" ng-if="\$ctrl.showEmptyReportMessage()">
    <span>No data matching the given criteria exist</span>
  </div>
</section>
<modal on-api-ready="\$ctrl.onModalReady">
  <modal-header>
    <h2>Set rows to print</h2>
    <span class="alert alert--info">Adjust these numbers if you are having problems printing large amount of data.</span>
  </modal-header>
  <modal-body>
   
    <ng-form name="\$ctrl.modalForm">
      <form-section>
        <form-section-field field-title="'Start'">
          <input type="number" min="1" ng-model="\$ctrl.start"></input>
        </form-section-field>
        <form-section-field field-title="'End'">
          <input type="number" min="1" ng-model="\$ctrl.end"></input>
        </form-section-field>
    </form-section>
    </ng-form>
   <div class="info-detail">
    <span class="key">Total no. of rows:</span>
    <span class="value">{{\$ctrl.reportContent[0].rows.length}}</span>
  </div>
  </modal-body>
  <modal-footer>
    <button type="button" ng-click="\$ctrl.rowModalApi.onCancel()" class="btn">Cancel</button>
    <button type="submit" ng-click="\$ctrl.rowModalApi.onOk()" class="btn btn-primary">
      Submit
    </button>
  </modal-footer>
</modal>

<modal on-api-ready="\$ctrl.onGenerateXmlOutputReady">
  <modal-header>
    <h2>Download Action</h2>
  </modal-header>
  <modal-body>
    Generating the XML output type will mark the selected period as "Submitted". Proceed?
  </modal-body>
  <modal-footer>
    <button type="button" ng-click="\$ctrl.generateXmlOutput.onCancel()" class="btn">No</button>
    <button type="submit" ng-click="\$ctrl.generateCocreeXml()" ng-disabled="!\$ctrl.modalForm.\$valid" class="btn btn-primary">
      Yes
    </button>
  </modal-footer>
</modal>

<modal on-api-ready="\$ctrl.onRegenerateCocreeModalReady">
  <modal-header>
    <h2>Download Action</h2>
  </modal-header>
  <modal-body>
    There is already a previously generated report for the selected period. Please choose an action.
  </modal-body>
  <modal-footer>
    <button type="button" ng-click="\$ctrl.onRegenerate()" class="btn">Regenerate</button>
    <button type="submit" ng-click="\$ctrl.onOverride()" class="btn btn-primary">
      Override
    </button>
  </modal-footer>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/report-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;